export enum PortalPagePowerBiType {
	Report = "report",
	Dashboard = "dashboard",
}
